import { Component } from '@angular/core'
import { Feature } from '@spartacus/core'
import { CurrentProductService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { EbProduct } from '../../interfaces/eb-product.interface'

@Component({
    selector: 'eb-product-specs-tab',
    templateUrl: './eb-product-specs-tab.component.html',
    styleUrls: ['./eb-product-specs-tab.component.scss'],
    standalone: false
})
export class EbProductSpecsTabComponent {
  product$: Observable<EbProduct>

  constructor(currentProductService: CurrentProductService) {
    this.product$ = currentProductService.getProduct() as Observable<EbProduct>
  }

  showFeatureValues(feature: Feature): string {
    const symbol = feature.featureUnit?.symbol || ''
    return (
      feature.featureValues.map(featureValue => featureValue.value).join(symbol + ', ') + ' ' + symbol
    )
  }

  isNumberFeatureAndHasEmptyValue(feature: Feature): boolean {
    return (
      feature.type?.toLowerCase() === 'number' &&
      feature.featureValues[0]?.value?.toString() === '0'
    )
  }
}
